
document.addEventListener("DOMContentLoaded", () => {
  try {
    import("../../common/demo/demo-resize");
    import("../../common/demo/resize");

    console.log("DOMContentLoaded, on main page");
  } catch (error) {
    console.error("An error occurred while loading the files on main page", error);
  }
});
